import React from 'react';
import { parseMathText } from '../utils/mathNotation';

function mathNodes(nodes) {
    return nodes.map((node, index) => {
        switch (node.type) {
            case 'fraction': return <mfrac key={index}><mrow>{mathNodes(node.numerator)}</mrow><mrow>{mathNodes(node.denominator)}</mrow></mfrac>;
            case 'root': return <msqrt key={index}>{mathNodes(node.children)}</msqrt>;
            case 'superscript': return <msup key={index}><mrow>{mathNodes(node.children)}</mrow><mrow>{mathNodes(node.script)}</mrow></msup>;
            case 'subscript': return <msub key={index}><mrow>{mathNodes(node.children)}</mrow><mrow>{mathNodes(node.script)}</mrow></msub>;
            case 'group': return <mrow key={index}>{mathNodes(node.children)}</mrow>;
            default: return <mtext key={index}>{node.text}</mtext>;
        }
    });
}

export default function MathText({ children }) {
    return <span className="ai-math-text">{parseMathText(children).map((segment, index) => segment.type === 'math'
        ? <math key={index} xmlns="http://www.w3.org/1998/Math/MathML"><mrow>{mathNodes(segment.nodes)}</mrow></math>
        : <React.Fragment key={index}>{segment.text}</React.Fragment>)}</span>;
}
